module.exports = __webpack_public_path__ + "static/media/Group.2e37be54.svg";